export const SENSOR_LABELS: Record<string, string> = {
    "sensor.inverter_output_l1_current": "Charging station line current (A)",
    "sensor.inverter_pv1_current": "Section 1 panel current (A)",
    "sensor.inverter_pv2_current": "Section 2 panel current (A)",
    "sensor.inverter_battery_current": "Battery input/output current (A)",
    "sensor.inverter_output_l1_power": "Cumulative power produced phase L1 (kWh)",
    "sensor.inverter_power": "Cumulative power produced",
    "sensor.inverter_load_l1_power": "Charging station power - Phase L1 (W)",
    "sensor.inverter_load_power": "Charging station power",
    "sensor.inverter_pv_power": "Total PV power (W)",
    "sensor.inverter_pv1_power": "PV power - section 1 (W)",
    "sensor.inverter_pv2_power": "PV power - section 2 (W)",
    "sensor.inverter_battery_power": "Battery power (W)",
    "sensor.inverter_power_losses": "Energy losses (W)",
    "sensor.inverter_pv1_voltage": "PV voltage - section 1 (V)",
    "sensor.inverter_pv2_voltage": "PV voltage - section 2 (V)",
    "sensor.inverter_battery_voltage": "Battery voltage (V)",
    "sensor.inverter_today_load_consumption": "Daily load consumption (kWh)",
    "sensor.inverter_today_production": "Daily PV production (kWh)",
    "sensor.inverter_total_production_b": "Total PV production (B) (kWh)",
    "sensor.inverter_total_production": "Total PV production (kWh)",
    "sensor.inverter_today_battery_charge": "Daily battery charge (kWh)",
    "sensor.inverter_today_battery_discharge": "Daily battery discharge (kWh)",
    "sensor.inverter_today_losses": "Daily energy losses (kWh)",
    "sensor.inverter_total_battery_charge": "Total battery charge (kWh)",
    "sensor.inverter_total_battery_discharge": "Total battery discharge (kWh)",
    "sensor.inverter_total_losses": "Total energy losses (kWh)",
    "sensor.inverter_total_load_consumption": "Total load consumption (kWh)",
    "sensor.inverter_battery": "Battery SOC (%)",
    "sensor.inverter_battery_soh": "Battery SOH (%)",
    "switch.inverter_battery_charge_discharge": "Battery Charge/Discharge",
    "sensor.inverter_battery_state": "Battery State",
    "sensor.inverter_battery_temperature": "Battery Temperature (°C)",
    "sensor.inverter_dc_temperature": "Inverter DC Temperature (°C)",
    "sensor.inverter_temperature": "Inverter Temperature (°C)",
    "sensor.inverter_update_interval": "Update Interval",
    "sensor.inverter_device_state": "Inverter state",
};

export const SENSOR_LIST = Object.keys(SENSOR_LABELS);

export const STATE_SENSORS = [
    "sensor.inverter_battery_state",
    "sensor.inverter_device_state",
    "switch.inverter_battery_charge_discharge"
];

export interface CombinedChart {
    id: string;
    title: string;
    entities: string[];
}

export const CROSS_LIST: CombinedChart[] = [
    {
        id: "pv_sections",
        title: "PV – sezioni vs totale",
        entities: ["sensor.inverter_pv1_power", "sensor.inverter_pv2_power", "sensor.inverter_pv_power"],
    },
    {
        id: "pv_vs_load",
        title: "Produzione vs Consumo",
        entities: ["sensor.inverter_pv_power", "sensor.inverter_load_power"],
    },
    {
        id: "pv_voltages",
        title: "Tensioni Stringhe PV",
        entities: ["sensor.inverter_pv1_voltage", "sensor.inverter_pv2_voltage"],
    },
    {
        id: "pv_currents",
        title: "Correnti Stringhe PV",
        entities: ["sensor.inverter_pv1_current", "sensor.inverter_pv2_current"],
    },
    {
        id: "energy_balance",
        title: "Bilancio Energetico (Potenze)",
        entities: ["sensor.inverter_pv_power", "sensor.inverter_load_power", "sensor.inverter_battery_power"],
    },
    {
        id: "device_temperatures",
        title: "Temperature Dispositivi",
        entities: ["sensor.inverter_temperature", "sensor.inverter_dc_temperature", "sensor.inverter_battery_temperature"],
    },
];

export const MANDATORY_CHARTS = [
    "sensor.inverter_battery",
    "sensor.inverter_pv_power",
    "pv_sections"
];

export const MAX_CHARTS_LIMIT = 10;

export const SENSOR_ORDER: string[] = [
    // Temperatura (priorità: inverter, DC, batteria)
    "sensor.inverter_temperature",
    "sensor.inverter_dc_temperature",
    "sensor.inverter_battery_temperature",

    // Umidità (non presente in SENSOR_LABELS: aggiungi qui se esiste davvero)
    // "sensor.inverter_humidity",

    // Percentuale batteria
    "sensor.inverter_battery",

    // Battery voltage
    "sensor.inverter_battery_voltage",

    // PV power (totale, poi sezioni)
    "sensor.inverter_pv_power",
    "sensor.inverter_pv1_power",
    "sensor.inverter_pv2_power",

    // PV voltage (sezioni)
    "sensor.inverter_pv1_voltage",
    "sensor.inverter_pv2_voltage",

    // Battery state
    "sensor.inverter_battery_state",
];